import { css } from 'styled-components'

const gutter = css`
  &-no-gutter {
    padding: 0 !important;
    max-width: 100% !important;
  }
`

export default gutter
